var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-half pt-0 specific text-center"},[_c('p',{class:`text-center mx-3 ${
          _vm.$root.selectedLanguage === `ta`
            ? `ta-line`
            : _vm.$root.selectedLanguage === `si`
            ? `si-line`
            : `en-line`
        }`},[_vm._v(" "+_vm._s(_vm.$root.selectedLanguageData.welcome)+" ")]),_c('p',{class:`${
          _vm.$root.selectedLanguage === `ta`
            ? `ta-sub-line`
            : _vm.$root.selectedLanguage === `si`
            ? `si-sub-line`
            : `en-sub-line`
        }`},[_vm._v(" "+_vm._s(_vm.$root.selectedLanguageData.onlineaccountopeningapplication)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }